import { render, staticRenderFns } from "./ChooseTherapist.vue?vue&type=template&id=04ba6811&scoped=true"
import script from "./ChooseTherapist.vue?vue&type=script&lang=js"
export * from "./ChooseTherapist.vue?vue&type=script&lang=js"
import style0 from "./ChooseTherapist.vue?vue&type=style&index=0&id=04ba6811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba6811",
  null
  
)

export default component.exports